import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import { Offcanvas, OffcanvasBody, OffcanvasHeader, Button } from 'reactstrap';
import AdminDisplay from '../components/AdminDisplay';
import CreateAdmin from '../components/CreateAdmin';
import ConvertToAdmin from '../components/ConvertToAdmin';

const Admins = ({ onLogout }) => {
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [isConvertOpen, setIsConvertOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');

    const toggleCreateCanvas = () => {
        setIsCreateOpen(!isCreateOpen);
        setRefreshKey(prevKey => prevKey + 1); // Refresh admin list
    }

    const toggleConvertCanvas = () => {
        setIsConvertOpen(!isConvertOpen);
    }

    const handleCreateSuccess = () => {
        setRefreshKey(prevKey => prevKey + 1); // Refresh admin list
    }

    const handleConvertSuccess = () => {
        setRefreshKey(prevKey => prevKey + 1); // Refresh admin list
    }

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    }

    return (
        <div className='d-flex w-100 overflow-hidden'>
            <div className='asidebar'>
                <Sidebar/>
            </div>
            <div className='main-content'>
                <div className='d-flex align-items-center justify-content-between mb-4'>
                    <h2>All Admin Users</h2>
                    <div className='d-flex align-items-center justify-content-end'>
                        <div className="me-3">
                            <input
                                type="text"
                                className="form-control rounded-50 ps-3"
                                style={{height: '50px', width: '250px'}}
                                placeholder="Search by name or email..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <button
                            type="button"
                            className="btn btn-success rounded-pill px-4 me-2"
                            onClick={toggleConvertCanvas}
                            style={{
                                height: '50px',
                                fontWeight: '600',
                                border: 'none',
                                minWidth: '180px'
                            }}
                        >
                            Convert to Admin
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary rounded-pill px-4"
                            onClick={toggleCreateCanvas}
                            style={{
                                height: '50px',
                                fontWeight: '600',
                                border: 'none',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                minWidth: '180px'
                            }}
                        >
                            Create Admin User
                        </button>
                    </div>
                </div>
                
                <AdminDisplay key={refreshKey} searchQuery={searchQuery} />
                
                <Offcanvas isOpen={isCreateOpen} toggle={toggleCreateCanvas} className="custom-canvas-width" direction='end'>
                    <OffcanvasHeader className='mb-4 mx-4 mt-2 border-bottom' toggle={toggleCreateCanvas}>
                        <span className='font-weight-bold'>Create Admin User</span>
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <CreateAdmin onClose={toggleCreateCanvas} onSuccess={handleCreateSuccess} />
                    </OffcanvasBody>
                </Offcanvas>

                <Offcanvas isOpen={isConvertOpen} toggle={toggleConvertCanvas} className="custom-canvas-width" direction='end'>
                    <OffcanvasHeader className='mb-4 mx-4 mt-2 border-bottom' toggle={toggleConvertCanvas}>
                        <span className='font-weight-bold'>Convert to Admin</span>
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <ConvertToAdmin onClose={toggleConvertCanvas} onSuccess={handleConvertSuccess} />
                    </OffcanvasBody>
                </Offcanvas>
            </div>
        </div>
    );
}

export default Admins;
